import styled, { keyframes } from 'styled-components';
import { v2Colors, v2FontFamily } from '../../formInputsV2/styles/tokens';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const popIn = keyframes`
  from { opacity: 0; transform: translateY(8px) scale(0.96); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: rgba(16, 24, 40, 0.55);
  backdrop-filter: blur(2px);
  animation: ${fadeIn} 160ms ease-out;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  padding: 34px 28px;
  background-color: ${v2Colors.inputBackground};
  border-radius: 20px;
  box-shadow: 0 24px 56px rgba(16, 24, 40, 0.28);
  font-family: ${v2FontFamily};
  animation: ${popIn} 200ms ease-out;

  @media (max-width: 560px) {
    max-width: 300px;
    gap: 18px;
    padding: 26px 20px;
  }
`;

export const Title = styled.p`
  margin: 0;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.45;
  color: ${v2Colors.text};
  white-space: nowrap;

  @media (max-width: 560px) {
    white-space: normal;
    font-size: 14px;
  }
`;

export const RingWrap = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 96px;
  height: 96px;

  svg {
    display: block;
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
  }

  .track {
    stroke: rgba(16, 24, 40, 0.1);
  }

  .progress {
    stroke: ${v2Colors.primary};
    stroke-linecap: round;
    transition: stroke-dashoffset 1s linear;
  }

  .value {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    font-weight: 700;
    color: ${v2Colors.primary};
    font-variant-numeric: tabular-nums;
  }

  @media (max-width: 560px) {
    width: 84px;
    height: 84px;

    .value {
      font-size: 24px;
    }
  }
`;
